// The WhatsApp support message names who is writing (BUG-642).
//
// The opener ends in "I need help with:" on purpose - as a complete sentence a
// third of members sent it and never wrote again; with the colon, 21% - so it
// stays LAST, with the cursor waiting for the need. What it lacked was WHO: the
// WhatsApp number is often not the one on the account. The member's profile
// code goes first, like a ticket reference; the server skips that line to read
// the opener's language. Mirrors `supportPrefilledMessage` in
// mobile_flutter/lib/core/utils/whatsapp_support.dart.

/** The prefilled text: "My profile code: WF-..." when known, then the opener. */
export function supportGreeting(t, formCode) {
  const opener = t('supportChat.greeting');
  return formCode ? `${t('supportChat.profileCodeLine', { code: formCode })}\n${opener}` : opener;
}

let cached = null;

/**
 * The member's own live profile code, fetched once per page load. Best effort:
 * a failure answers null and the opener goes alone.
 * @param {() => Promise<{data: any}>} fetchMyForms
 */
export function ownFormCode(fetchMyForms) {
  if (!cached) {
    cached = fetchMyForms()
      .then((res) => {
        const forms = res?.data?.forms || (Array.isArray(res?.data) ? res.data : []);
        const live = forms.find((f) => f && f.status !== 'deleted' && f.form_code);
        return live ? live.form_code : null;
      })
      .catch(() => {
        cached = null;
        return null;
      });
  }
  return cached;
}

/** Test seam: forget the cached lookup. */
export function resetOwnFormCode() {
  cached = null;
}
